import React, {useEffect, useState} from "react";
import {BarChart, Bar, CartesianGrid, XAxis, YAxis, Legend, Tooltip} from "recharts";
import moment from "moment";
const ManagerStatistics=({reservationList})=>{
    const [chartData,setChartData]=useState([]);
    const [chartData2,setChartData2]=useState([]);
    const initData=[
        {
            months:'01',
            count: 0,
        },
        {
            months:'02',
            count: 0,
        },
        {
            months:'03',
            count: 0,
        },
        {
            months:'04',
            count: 0,
        },
        {
            months:'05',
            count: 0,
        },
        {
            months:'06',
            count: 0,
        },
        {
            months:'07',
            count: 0,
        },
        {
            months:'08',
            count: 0,
        },
        {
            months:'09',
            count: 0,
        },
        {
            months:'10',
            count: 0,
        },
        {
            months:'11',
            count: 0,
        },
        {
            months:'12',
            count: 0,
        },
    ];
    const [thisMountCount,setThisMountCount]=useState(0);
    const [thisPrice,setThisPrice]=useState(0);
    const [allPrice,setAllprice]=useState(0)
    const [dayCount,setDayCount]=useState(0);
    const [monthPrice,setMonthPrice]=useState(0);

    useEffect(()=>{
        let check = moment().format( 'MM');
        let count=0;
        let price=0;
        reservationList.map((item)=>{
            if(item.usertime.slice(5,7)===check){
                count+=1;
                price+=item.priceAll
            }
        })
        setThisMountCount(count)
        setThisPrice(price)
    },[])

    const ChartMaker=()=>{
        const now = new Date();
        console.log(reservationList)
        let arr =initData;
        let price = 0;
        reservationList.map(item=>{
            arr.map(item2=>{
                    if(item.usertime.slice(5,7)===item2.months){
                        item2.count+=1
                        price+=item.priceAll
                    }
                }
            )
        })
        setAllprice(price)
        setChartData(arr)
        ChartMakerDays(now.getMonth()+1)
    }
    const ChartMakerDays=(month)=>{
        let lastDate = new Date(2019, month, 0).getDate();
        let arr =[]
        let count =0
        let price =0
        for(let i=1; i<=lastDate; i++){
            arr.push({
                day: i,
                count: 0
            })
        }
        reservationList.map(item=>{
            if(Number(item.usertime.slice(5,7))===Number(month)){
                price+=item.priceAll
                arr.map(item2=>{
                    if(item2.day===Number(item.usertime.slice(8,10))){
                        arr[item2.day-1].count+=1
                    }
                })
                count+=1
            }
        })
        setMonthPrice(price)
        setDayCount(count)
        setChartData2(arr)
    }

    return(
        <div className={'flex__center manager-statistics-container'}>
            <div className={'flex__column manager-statistics'}>
                <span>이번달 예약건수:{thisMountCount}건</span>
                <span>이번달 판매실적: {thisPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 원</span>
            </div>
            <div className={'flex__column'}>
                <button onClick={()=>{ChartMaker()}}>통계 보기</button>
                <div className={'flex__low manager-statistics'}>
                    <div className={'flex__center'}>
                        <h3>월별통계</h3>
                        <div className={'flex__center'}>
                            <span>총 예약건수: {reservationList.length} </span>
                            <span>총 매출: {allPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 원</span>
                        </div>
                        <BarChart
                            width={300}
                            height={300}
                            data={chartData}>
                            <CartesianGrid strokeDasharray="3 3"/>
                            <XAxis dataKey="months"/>
                            <YAxis/>
                            <Tooltip/>
                            <Legend/>
                            <Bar dataKey="count" fill="#82ca9d"/>
                        </BarChart>
                    </div>
                    <div>
                        <div className={'flex__center flex__low'}>
                            <h3>일별통계</h3>
                            <select defaultValue={0} onChange={(e)=>ChartMakerDays(e.target.value)}>
                                <option value={0}>기본:당월</option>
                                <option value={1}>1월</option>
                                <option value={2}>2월</option>
                                <option value={3}>3월</option>
                                <option value={4}>4월</option>
                                <option value={5}>5월</option>
                                <option value={6}>6월</option>
                                <option value={7}>7월</option>
                                <option value={8}>8월</option>
                                <option value={9}>9월</option>
                                <option value={10}>10월</option>
                                <option value={11}>11월</option>
                                <option value={12}>12월</option>
                            </select>
                        </div>
                        <div className={'flex__center'}>
                            <span>해당월 총 예약건수: {dayCount}</span>
                            <span>해당월 총 매출: {monthPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 원</span>
                        </div>
                        <BarChart
                            width={300}
                            height={300}
                            data={chartData2}>
                            <CartesianGrid strokeDasharray="3 3"/>
                            <XAxis dataKey="day"/>
                            <YAxis/>
                            <Tooltip/>
                            <Legend/>
                            <Bar dataKey="count" fill="#82ca9d"/>
                        </BarChart>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ManagerStatistics;
